<template>
  <modal
    v-model="termsNotAccepted"
    :backdrop="false"
    :dismiss-btn="false"
    :aria-modal="true"
    id="terms-of-use-modal"
  >
    <template #title>
      <h3 id="terms-of-use-title" aria-live="assertive">Please Accept Our Updated Terms of Use</h3>
    </template>
    <div class="modal-body">
      Hi {{ userName && userName.split(' ')[0] }},<br >
      <p>We have recently updated our Terms of Use.</p>
      <a
        href="https://goalbook.com/terms"
        target="_blank"
        rel="noopener noreferrer"
        class="termsofuse">
        Click to view Terms of Use
      </a>
      <br >
      <p>To continue using Toolkit you must accept these updated terms.</p>
    </div>

    <transition name="fade">
      <alert
        type="danger"
        class="action-alert text-center"
        @dismissed="terms_accepted_error = false"
        v-if="terms_accepted_error">
        There was an error accepting the terms of use. Please try again. Contact support if issues persist.
      </alert>
    </transition>

    <div slot="footer">
      <button
        id="accept-terms-btn"
        ref="termsButton"
        class="btn btn-primary"
        @click="confirmAcceptTerms"
      >I accept these terms
      </button>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
    name: 'TermsOfUseModal',
    computed: {
        ...mapGetters('user', ['userName', 'termsNotAccepted']),
        ...mapState('user', ['terms_accepted_error'])
    },
    methods: {
        confirmAcceptTerms: function() {
            this.$store.dispatch('user/acceptTerms')
        }
    }
}
</script>


<style scoped>
  .termsofuse {
    display: block;
    text-align: center;
    border: 1px solid #eee;
    padding: 10px;
  }

  .termsofuse:hover {
    background: #efefef;
  }

  #terms-of-use-title {
    text-align: center;
    font-weight: 300;
  }

  .modal-body {
    font-size: 16px;
    font-weight: 300;
  }
</style>